/* eslint-disable prettier/prettier */
/* eslint-disable import/no-duplicates */
import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { format, parseISO } from 'date-fns';

import { Container, Button, Row, Col } from 'react-bootstrap';

import { FaFileDownload } from 'react-icons/fa';
import api from '../../../services/api';

import { formatPrice, TIPO_USUARIO } from '../../../utils/funcoes';

import { useToast } from '../../../hooks/toast';
import { useClinica } from '../../../hooks/clinica';
import { useAuth } from '../../../hooks/auth';
import { usePerfil } from '../../../hooks/perfil';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import SelectSync, { IOption } from '../../../components/SelectSync';
import Loading from '../../../components/Loading';

import getValidationErrors from '../../../utils/getValidationErrors';


import getResponseErrors from '../../../utils/getResponseErrors';
import PageInfo from '../../../components/PageInfo';
import HeaderRelatorio from '../HeaderRelatorio';

interface IRelatorio {
  id: number;
  AgeCodigo: number;
  ParCodigo: number;
  AgeInicio: Date;
  AgeInicioFormatado: string;
  created_at: Date;
  updated_at: Date;
  PacCodigo: number;
  PacNome: string;
  PacCPF: string;
  procedimentos: string;
  resultado: boolean;
  resultadoFormatado: string;
  FormaPag: string;
  CprClinica: number;
  CprValorPag: number;
  CprValorPagFormatado: string;
  ParRazaoSocial: string;
}


interface ITotais {
  totalPagoFormatado: string;
}

interface IFormBusca {
  dataInicio: Date;
  dataFim: Date;
  CliCodigo: string;
  // PerCodigo: string;
  ParCodigo: string;
  resultado: string;
}

interface ITituloExibe {
  dataHora: string;
  titulo: string;
}
interface IParceiro {
  ParCodigo: number;
  ParRazaoSocial: string;
  ParTelefone: string;
  ParCelular: string;
  ParEmail: string;
  ParEndereco: string;
  ParNumero: string;
  ParBairro: string;
  ParCidade: string;
  ParCEP: string;
  ParComplemento: string;
  ParUF: string;
}

const optionsResultado: IOption[] = [
  { value: '', label: '' },
  { value: 'true', label: 'Sim' },
  { value: 'false', label: 'Não' },
];

const FechamentoParceiroVoucher: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();
  const { user, clinica } = useAuth();
  const { optionsClinica } = useClinica();

  const { optionsPerfil, buscaPerfil } = usePerfil();


  const [optionPerfil, setOptionsPerfil] = useState<IOption[]>([]);
  const [optionsParceiro, setOptionsParceiro] = useState<IOption[]>([]);

  const formRefBusca = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const [dadosRelatorio, setDadosRelatorio] = useState<IRelatorio[]>();
  const [totais, setTotais] = useState<ITotais>();

  const initialData = {
    dataInicio: format(new Date(), 'yyyy-MM-dd'),
    dataFim: format(new Date(), 'yyyy-MM-dd'),
    CliCodigo: user.UsuClinica.toString(),
  };
  const [tituloExibe, setTituloExibe] = useState<ITituloExibe>();
  const [clinicaSelecionada, setClinicaSelecionada] = useState('');

  const exibeTotais =
    (clinica.CliDrSaude && user.UsuTipo === TIPO_USUARIO.ADMINISTRADOR) ||
    (!clinica.CliDrSaude && user.UsuTipo <= TIPO_USUARIO.SUPERVISOR);

  const informacoesPagina = `<b>Descrição:</b> Exibe todos os voucher consumidos pelo parceiro, em um determinado período.`;

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);


  useEffect(() => {
    async function loadParceiros(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IParceiro[]>(`/parceiros/lista`);

        const options: IOption[] = response.data.map((op: IParceiro) => ({
          value: op.ParCodigo.toString(),
          label: op.ParRazaoSocial,
        }));

        setOptionsParceiro(options);

      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar parceiros',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);

      }
    }

    loadParceiros();
  }, [addToast]);

  useEffect(() => {
    try {
      setOptionsPerfil(optionsPerfil.optionPerfis);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfis',
        type: 'error',
      });
    }
  }, [addToast, optionsPerfil]);

  useEffect(() => {
    if (user.UsuTipo > TIPO_USUARIO.ATENDENTE_CAIXA) {
      history.push('/sempermissao');
    }
  }, [history, user.UsuTipo]);

  const validaDadosERetornaParametros = useCallback(async (): Promise<string> => {
    formRefBusca.current?.setErrors({});
    const schema = Yup.object().shape({
      dataInicio: Yup.date().required(),
      dataFim: Yup.date().required(),
      CliCodigo: Yup.string().required(),
      ParCodigo: Yup.string().nullable(true),
      PerCodigo: Yup.string().nullable(true),
      resultado: Yup.string().nullable(true),
    });

    const dados: IFormBusca = {
      dataInicio: formRefBusca.current?.getFieldValue('dataInicio'),
      dataFim: formRefBusca.current?.getFieldValue('dataFim'),
      CliCodigo: formRefBusca.current?.getFieldValue('CliCodigo'),
      // PerCodigo: formRefBusca.current?.getFieldValue('PerCodigo'),
      ParCodigo: formRefBusca.current?.getFieldValue('ParCodigo'),
      resultado: formRefBusca.current?.getFieldValue('resultado'),
    };

    await schema.validate(dados, {
      abortEarly: false,
    });

    const dataInicioSelecionada = parseISO(dados.dataInicio.toString());
    const dataFimSelecionada = parseISO(dados.dataFim.toString());

    const dataInicioFormatada = format(dataInicioSelecionada, 'yyyy-MM-dd');
    const dataFimFormatada = format(dataFimSelecionada, 'yyyy-MM-dd');

    const clinicaSelected = optionsClinica.find(cli => cli.value === dados.CliCodigo)?.label || '';
    setClinicaSelecionada(clinicaSelected);


    const parceiroSelecionado = formRefBusca.current?.getFieldValue('ParCodigo');

    const nomeParceiro = optionsParceiro.find(par => par.value === parceiroSelecionado)?.label || '';

    const diaSemana = `${format(
      dataInicioSelecionada,
      'dd/MM/yyyy',
    )} até ${format(dataFimSelecionada, 'dd/MM/yyyy')}`;

    const titulo = `FECHAMENTO VOUCHER ${clinicaSelected.length > 0 ? `- ${clinicaSelected} ` : ''
      } ${nomeParceiro !== '' ? `- ${nomeParceiro} -` : '-'}
            ${diaSemana || ''}`;


    setTituloExibe({
      dataHora: format(new Date(), 'dd/MM/yyyy HH:mm:ss'),
      titulo,
    });
    let parametrosOpcionais = '';
    // parametrosOpcionais = dados.PerCodigo
    //   ? `&PerCodigo=${dados.PerCodigo}`
    //   : '';

    parametrosOpcionais += dados.ParCodigo
      ? `&ParCodigo=${dados.ParCodigo}`
      : '';

    parametrosOpcionais += dados.resultado
      ? `&resultado=${dados.resultado}`
      : '';

    return `dataInicio=${dataInicioFormatada}&dataFim=${dataFimFormatada}&CliCodigo=${dados.CliCodigo}${parametrosOpcionais}`;
  }, [optionsClinica, optionsParceiro]);

  const handleSubmitBusca = useCallback(
    async (dados: IFormBusca) => {
      setLoading(true);
      try {
        setDadosRelatorio(undefined);

        const parametros = await validaDadosERetornaParametros();

        const response = await api.get<IRelatorio[]>(
          `/relatorios/voucherparceiros?${parametros}`,
        );

        let totalGeralPago = 0;

        const dadosFormatados = response.data.map(rel => {
          return {
            ...rel,
            AgeInicioFormatado: format(
              parseISO(rel.AgeInicio.toString()),
              'dd/MM/yyyy',
            ),
            resultadoFormatado: rel.resultado ? 'Sim' : 'Não',
            CprValorPagFormatado: formatPrice(rel.CprValorPag),
          };
        });

        const totalPago = dadosFormatados.reduce((tot, item) => {
          return tot + Number(item.CprValorPag);
        }, 0);

        totalGeralPago += totalPago;


        setDadosRelatorio(dadosFormatados);
        setTotais({
          totalPagoFormatado: formatPrice(totalGeralPago),
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefBusca.current?.setErrors(errors);
        } else {
          const mensagem = getResponseErrors(error);
          addToast({
            type: 'error',
            title: 'Não foi possível carregar dados',
            description: mensagem,
          });
        }
      } finally {
        setLoading(false);
      }
    },
    [addToast, validaDadosERetornaParametros],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function, prettier/prettier
  const handleOnChangeVazio = useCallback(() => { }, []);

  const handleDownload = useCallback(async () => {
    setLoading(true);
    try {
      const parametros = await validaDadosERetornaParametros();
      const response = await api.get(
        `/relatorios/procedimentosrealizadosconvenioexport?${parametros}`,
      );

      // let headerLine = response.headers['content-disposition'];
      // let startFileNameIndex = headerLine.indexOf('"') + 1
      // let endFileNameIndex = headerLine.lastIndexOf('"')
      // let filename = headerLine.substring(startFileNameIndex, endFileNameIndex)

      const link = document.createElement('a');
      link.href = response.data.url;
      link.setAttribute(
        'download',
        `procedimentoValor${Math.floor(Date.now() / 1000)}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      } else {
        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Não foi possível carregar dados',
          description: mensagem,
        });
      }
    } finally {
      setLoading(false);
    }
  }, [addToast, validaDadosERetornaParametros]);

  // const handleChangeConvenio = useCallback(({ label }: IOption) => {
  //   setConvenioSelecionado(label.toUpperCase());
  //   formRefBusca.current?.submitForm();
  // }, []);

  return (
    <Container fluid className="mt-2">
      {loading && <Loading />}
      <>
        <div className="d-print-none bg-white border p-2 mb-2">
          <div className="p-2 mb-2 d-flex justify-content-between">
            <h2 id="topoBusca">Consumo de Voucher</h2>
            <PageInfo
              descricao={informacoesPagina}
              permissao={TIPO_USUARIO.ATENDENTE_CAIXA}
            />
          </div>

          {optionsClinica.length > 0 && optionsParceiro.length > 0 && user && (
            <Form
              ref={formRefBusca}
              initialData={initialData}
              onSubmit={handleSubmitBusca}
            >
              <Row>
                <Col md={2}>
                  <Input name="dataInicio" label="De" type="date" required />
                </Col>
                <Col md={2}>
                  <Input name="dataFim" label="Até" type="date" required />
                </Col>
                <Col md={2}>
                  <Select
                    name="CliCodigo"
                    label="Clinica"
                    options={optionsClinica}
                    disabled={user.UsuTipo !== TIPO_USUARIO.ADMINISTRADOR}
                  />
                </Col>

                {/* <Col md={2}>
                  <SelectSync
                    name="PerCodigo"
                    label="Perfil"
                    options={optionPerfil}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col> */}
                <Col md={2}>
                  <SelectSync
                    name="ParCodigo"
                    label="Parceiro"
                    options={optionsParceiro}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                <Col md={1}>
                  <SelectSync
                    name="resultado"
                    label="Resultado"
                    options={optionsResultado}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col>
                {/* <Col md={2}>
                   <SelectSync
                    name="ConvCodigo"
                    label="Convênio"
                    options={optionsConvenio}
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col> */}
                {/* <Col md={2}>
                  <SelectAsync
                    urlApi="procedimentos/combo?termoBusca="
                    name="ProCodigo"
                    label="Procedimento"
                    placeholder="Procurar"
                    isClearable
                    handleSelectChange={handleOnChangeVazio}
                  />
                </Col> */}

                <Col md={1}>
                  <br />
                  <Button type="submit" size="sm" variant="outline-secondary">
                    BUSCAR
                  </Button>
                </Col>
                {/* <Col md={1}>
                  <br />
                  <Button
                    type="button"
                    size="sm"
                    variant="outline-success"
                    disabled={!dadosRelatorio}
                    onClick={() => handleDownload()}
                  >
                    <FaFileDownload />
                  </Button>
                </Col> */}
              </Row>
            </Form>
          )}
        </div>

        <HeaderRelatorio
          dataImpressao={tituloExibe?.dataHora}
          titulo={tituloExibe?.titulo || 'FECHAMENTO VOUCHER'}
        />

        <div className="bg-white border p-2">
          {dadosRelatorio && (
            <>
              <table
                className="table table-hover table-sm table-font-small table-bordered"
                style={{ borderWidth: '0px' }}
              >
                <thead>
                  <tr className="text-center">
                    <th style={{ width: '80px' }}>Data</th>
                    <th style={{ minWidth: '100px' }}>Nº Voucher</th>
                    <th>Paciente</th>
                    <th style={{ width: '90px' }}>CPF</th>
                    <th style={{ width: '80px' }}>Resultado</th>
                    <th>Procedimento</th>
                    <th style={{ minWidth: '115px' }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosRelatorio &&
                    dadosRelatorio.map(relatorio => (

                      <tr
                        key={`voucher-${relatorio.AgeCodigo}-${relatorio.ParCodigo}`}
                        data-id={relatorio.AgeCodigo}
                        style={{ fontSize: '.7rem', height: '30px' }}
                      >
                        <td>{relatorio.AgeInicioFormatado}</td>
                        <td>{relatorio.AgeCodigo}</td>

                        <td>{relatorio.PacNome}</td>
                        <td>{relatorio.PacCPF}</td>
                        <td>{relatorio.resultadoFormatado}</td>
                        <td>{relatorio.procedimentos}</td>
                        <td>{relatorio.CprValorPagFormatado}</td>
                      </tr>
                    ))}

                  {exibeTotais && (
                    <tr
                      key="fdfdsfsdfdf"
                      style={{
                        fontSize: 'Small',
                        height: '30px',
                        fontWeight: 'bold',
                      }}
                    >

                      {/* <td>Total Desc: {totais?.totalDescontoFormatado}</td> */}
                      <td colSpan={7} style={{ textAlign: 'right' }}>
                        Total: {totais?.totalPagoFormatado}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
          )}
        </div>
      </>
    </Container>
  );
};

export default FechamentoParceiroVoucher;
